module.exports = "/images/sala_viajero_pv05.jpg?77afc9bb6d55554d74adbdfa559edc63";